/* eslint-disable no-console */
import { useCallback } from "react";
import { useSelector } from "react-redux";

import { Routes } from "@/config/page-view-constants";
import axioInstance from "@/libs/axios";
import { RootState } from "@/store/root-reducer";

export const modalEventsforBE = {
  MOUSE_AWAY: "MOUSE_MOVE_AWAY",
  IDLE: "90_SEC_IDLE",
};

export const variationsForBE = {
  control: "control",
  variantA: "variant-A",
  variantB: "variant-B",
};

export type ModalRequest = {
  modalLoaded: boolean;
  modalLoadedEvent: string | null;
  variation: string;
};

export type ModalData = ModalRequest & {
  version: string;
};

export type ModalDetailsPayloadType = {
  data: {
    type: string;
    channel: string;
    version?: string;
    viewPage?: string;
    attributes: {
      domain?: string;
      experimentDetails?: {
        ecoExitIntentFlow?: string;
      };
      priceResult: {
        ecoSystem: ModalRequest;
      };
    };
  };
};

// Custom hook for fetching data
export default function usePtmmExitModalDetails() {
  const { attributes, referenceId } = useSelector(
    (state: RootState) => state.quote
  );

  const passModalDetails = useCallback(
    async (payloadData: ModalData) => {
      const payLoad: ModalDetailsPayloadType = {
        data: {
          type: "Quote",
          channel: "ONLINE",
          version: payloadData.version,
          viewPage: Routes.Quote,
          attributes: {
            domain: attributes.domain,
            experimentDetails: {
              ecoExitIntentFlow: payloadData.variation,
            },
            priceResult: {
              ecoSystem: {
                modalLoaded: payloadData.modalLoaded,
                modalLoadedEvent: payloadData.modalLoadedEvent,
                variation: payloadData.variation,
              },
            },
          },
        },
      };

      const url = `/quote/${referenceId}/ecoSystem`;

      try {
        await axioInstance.patch(url, payLoad);
      } catch (ex) {
        console.log(ex);
        // Silent fail as per original implementation
      }
    },
    [attributes.domain, referenceId]
  );

  return { passModalDetails };
}
